const SLIDE_SHOW_CLASS = '.my-slideshow';
const SLIDE_SHOW_SLIDE_CLASS = '.my-slideshow__slide';

function onIntersection(elements, observer) {
    elements.forEach((element, index) => {
        const elementTarget = element.target;
        if (element.isIntersecting) {
            if (!elementTarget.dataset.int) {
                startSlideShow(elementTarget)
            }
        } else {
            if (elementTarget.dataset.int) {
                stopSlideShow(elementTarget)
            }
        }
    });
}

function startSlideShow(slideShowEl) {
    const displayTime = slideShowEl.dataset.speed || 3;
    const slides = slideShowEl.querySelectorAll(SLIDE_SHOW_SLIDE_CLASS);
    let currentSlide = slideShowEl.dataset.index || 0;
    function showSlide(n) {
        slides.forEach(slide => slide.classList.remove('active-slide', 'previous-slide', 'next-slide'));
        slides[(n - 1 + slides.length) % slides.length].classList.add('previous-slide');
        slides[n].classList.add('active-slide');
        slides[(n + 1) % slides.length].classList.add('next-slide');
        slideShowEl.dataset.index = n;
    }
    function nextSlide() {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
    }
    showSlide(currentSlide);
    slideShowEl.dataset.int = setInterval(nextSlide, displayTime * 1000);

}
function stopSlideShow(slideShowEl) {
    clearInterval(slideShowEl.dataset.int);
    delete slideShowEl.dataset.int;
}


function initializeSlideShows(rootEl = document, isDesignModeEvent = false) {
    const slideShows = Array.from(rootEl.querySelectorAll(SLIDE_SHOW_CLASS));
    if (slideShows.length === 0) return;
    const observer = new IntersectionObserver(onIntersection, {
        rootMargin: '-50px 0px -50px 0px',
    });
    if (isDesignModeEvent) {
        observer.disconnect();
    }
    slideShows.forEach((element) => observer.observe(element));
}



window.addEventListener('DOMContentLoaded', () => {
    initializeSlideShows();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => isDesignModeEvent(event.target, true));
    document.addEventListener('shopify:section:reorder', () => isDesignModeEvent(document, true));
}
